import type { IconSvgObject } from './types';

const NotepadTextDashedIcon: IconSvgObject = [
  ["path", { d: "M16.5 2V5M7.5 2V5M12 2V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 12V14M4 8V5.5C4 4.39543 4.89543 3.5 6 3.5H7.5M4 18V20C4 21.1046 4.89543 22 6 22H7M20 8V5.5C20 4.39543 19.1046 3.5 18 3.5H16.5M20 12V14M20 18V20C20 21.1046 19.1046 22 18 22H17M11 22H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 15H12M8 11H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default NotepadTextDashedIcon;
